import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/intransit-inv", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/intransit-inv/csv", params);
};

const upsert = data => {
  return restApi.post("/api/intransit-inv/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/intransit-inv/${ids}`);
};

const intransitInvService = {
  getAll,
  getAllForCSV,
  upsert,
  remove
};

export default intransitInvService;